import { render, staticRenderFns } from "./AccountAccepted.vue?vue&type=template&id=6bb56942&"
import script from "./AccountAccepted.vue?vue&type=script&lang=ts&"
export * from "./AccountAccepted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports